import {reqget, reqpost} from "./axiosFun";

export const settingList = (params) => { return reqget("get", "/api/setting/list",params) };
export const updateSetting = (params) => { return reqpost("put", `/api/setting/${params.id}`, params) };
export const addSetting = (params) => { return reqpost("post", `/api/setting`, params) };

// 会员套餐
export const memberComboList = (params) => { return reqget("get", "/api/member/combo/list",params) };
export const updateMemberCombo = (params) => { return reqpost("put", `/api/member/combo/${params.id}`, params) };
export const addMemberCombo = (params) => { return reqpost("post", `/api/member/combo`, params) };
export const deleteMemberCombo = (params) => { return reqpost("delete", `/api/member/combo/${params.ids}`, params) };

// 会员特权
export const privilegeList = (params) => { return reqget("get", "/api/privilege/list",params) };
export const updatePrivilege = (params) => { return reqpost("put", `/api/privilege/${params.id}`, params) };
export const addPrivilege = (params) => { return reqpost("post", `/api/privilege`, params) };
export const deletePrivilege = (params) => { return reqpost("delete", `/api/privilege/${params.ids}`, params) };


export const sourceConfigList = (params) => { return reqget("get", `/api/source-config/getList`, params) };



// WEBPACK FOOTER //
// ./src/api/configMG.js